import { createFileRoute } from '@tanstack/react-router'
import { RequireAuth } from '@dss/auth'
import { OwnersScreen } from '../features/owners/OwnersScreen'

export const Route = createFileRoute('/owners')({
  component: () => <RequireAuth><OwnersScreen /></RequireAuth>,
})
